<template>
    <v-card flat>
        <v-card-text v-if="myData">
            <v-row v-for="prax,index in myData.praxe" :key="index" style="margin:3px">
                <v-col cols=12>
                    <v-row>
                    <div>
                        <h2>
                        <span v-if="prax.archivovane==1"><v-icon title="Archivovaná">handshake</v-icon> &nbsp;&nbsp;</span>
                        <span v-if="prax.stav=='nová'">
                            <v-icon title="Edituj prax" style="cursor:pointer" @click="editujPrax(prax)">edit</v-icon> 
                            <v-icon title="Vymaž prax" style="cursor:pointer" @click="deletePrax(prax.id)">delete</v-icon> 
                        </span>
                        {{prax.nazov}} ({{prax.mesto}})
                        </h2>
                        <p align="center">{{prax.od_den}}.{{prax.od_mesiac}}.{{prax.od_rok}} - {{prax.do_den}}.{{prax.do_mesiac}}.{{prax.do_rok}},
                            stav: {{prax.stav}}</p>
                    </div>
                        <v-spacer />                    
                        <v-btn variant="outlined" @click="ukazTerminy()" style="margin-right:3px">Termíny</v-btn>
                        <v-btn variant="outlined" @click="ukazVysledky()">Výsledky</v-btn>
                    </v-row>
                </v-col>
                <v-col cols=12>    
                    <v-card variant="outlined" v-if="ukaz_terminy == 1" style="background-color:#E8F5E9">
                        <v-card-title>
                            <v-icon large class="btn-close" @click="ukaz_terminy = 0">close</v-icon>
                            Termíny prezentácie
                        </v-card-title>
                        <v-card-text>
                            <br>
                            <v-row v-for="termin,index2 in prax.terminy" :key="index2" style="margin-left:10px">
                                <v-card variant="outlined" style="width:100%;background-color:#E8F5E9;margin:3px">
                                    <v-card-title>
                                        <v-row style="margin:5px">
                                            ({{termin.pocet_miest-termin.volne}} / {{termin.pocet_miest}})
                                            &nbsp;&nbsp;
                                            <b>{{termin.termin}}</b>
                                            <v-spacer></v-spacer>
                                            <v-icon v-if="prax.termin_id == termin.id" large color="green">done</v-icon>
                                            <v-spacer></v-spacer>
                                            <v-icon v-if="termin.volne>0" title="Zapíš ma" style="margin-right:10px;color:green" @click="zapisMa(termin.id, prax.id)">person_add</v-icon>
                                            <v-icon v-if="prax.termin_id == termin.id" title="Odhlás ma" style="margin-right:10px; color:red" @click="odhlasMa(termin.id, prax.id)">person_remove</v-icon>
                                        </v-row>
                                    </v-card-title>
                                </v-card>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <PracticeResults v-if="ukaz_vysledky == 1" />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-row style="margin:1px" v-if="ukazat_prax == 0">
                <v-spacer />
                <v-btn variant="outlined" @click="nacitajFirmy()">Pridaj prax</v-btn>
                <v-spacer />
            </v-row>
            <v-row style="margin:1px" v-if="MyFirmy!=null && ukazat_prax == 1">
                <v-spacer />
                <v-card variant="outlined" style="width:95%">
                    <v-card-text style="background-color:#E8F5E9">
                        <v-icon large class="btn-close" @click="ukazat_prax = 0">close</v-icon>
                        <v-row style="margin:5px" v-if="pridat_firmu==0">
                            <v-spacer />
                            <v-combobox label="Firma" variant="outlined" 
                                :items="MyFirmy.firmy" 
                                item-title="popis"
                                item-value="id"
                                v-model="selected_firm"
                                density="compact"  
                                style="width:70%"                                                  
                            />                            
                            <v-btn variant="outlined" style="margin-left:5px" dense @click="pridajFirmu()">Pridať firmu</v-btn>
                            <v-spacer />
                        </v-row>
                        <v-row v-if="pridat_firmu==1 || editovana_firma > 0" style="margin:2px">
                            <v-card style="width:100%">
                                <v-card-title> 
                                    <v-icon large class="btn-close" @click="pridat_firmu = 0; editovana_firma = 0">close</v-icon>
                                    Údaje firmy
                                </v-card-title>
                                <v-card-text>                                    
                                    <v-text-field v-model="firma_nazov" label="Názov" density="compact" variant="outlined"/>
                                    <v-text-field v-model="firma_ulica" label="Ulica" density="compact" variant="outlined"/>
                                    <v-text-field v-model="firma_mesto" label="Mesto" density="compact" variant="outlined"/>
                                    <v-text-field v-model="firma_psc" label="PSČ" density="compact" variant="outlined"/>
                                    <v-text-field v-model="firma_ico" label="IČO" density="compact" variant="outlined"/>
                                    <p v-if="firma_feedback.length>0" style="color:red">{{firma_feedback}}</p>
                                    <v-btn variant="outlined" @click="ulozFirmu()">Ulož Firmu</v-btn>
                                </v-card-text>
                            </v-card>
                        </v-row>
                        <v-card variant="flat" style="background-color:#E8F5E9;width:80%" v-if="selected_firm && pridat_firmu == 0 && editovana_firma < 1">
                            <v-card-text>
                                <div>
                                    <div v-if="$store.getters.getUser.user_id == selected_firm.creator_id" class="btn-close">
                                        <v-icon @click="editujFirmu(selected_firm)">edit</v-icon>
                                        <v-icon @click="vymazFirmu(selected_firm.id)">delete</v-icon>
                                    </div>
                                    {{selected_firm.nazov}} <br>
                                    {{selected_firm.ulica}} <br>
                                    {{selected_firm.psc.substring(0,3) + ' '+selected_firm.psc.substring(3,5)}} {{selected_firm.mesto}} <br>
                                    ICO: {{selected_firm.ico.substring(0,2)+' '+selected_firm.ico.substring(2,5)+' '+selected_firm.ico.substring(5)}}
                                    <p v-if="firma_feedback.length>0" style="color:red">{{firma_feedback}}</p>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                    <v-card-text v-if="selected_firm">
                        <b>Kontaktná osoba (vyber kliknutím):</b>
                            <div v-if="pridat_kontakt==0" style="margin:1px">
                                <p 
                                    v-for="(osoba,index2) in selected_firm.kontakty" :key="index2" 
                                    >                                    
                                        <v-icon v-if="kontaktna_osoba_id == osoba.id" style="color:green" @click="kontaktna_osoba_id = -1" >done </v-icon>
                                        <v-icon size="x-small" v-if="kontaktna_osoba_id != osoba.id" style="color:#E8F5E9" @click="kontaktna_osoba_id = osoba.id" >radio_button_unchecked </v-icon>
                                        {{osoba.priezvisko}} {{osoba.meno}}, e-mail: {{osoba.email}}
                                        <v-icon v-if="$store.getters.getUser.user_id == osoba.creator_id" @click="editujKontakt(osoba)">edit</v-icon>
                                        <v-icon v-if="$store.getters.getUser.user_id == osoba.creator_id" @click="vymazKontakt(osoba.id)">delete</v-icon>
                                </p>
                                <p v-if="kontakt_feedback.length>0" style="color:red">{{kontakt_feedback}}</p>
                            </div>
                            <v-row style="margin:5px" v-if="pridat_kontakt == 0 && editovany_kontakt == 0">
                                <v-spacer />
                                <v-btn variant="outlined" @click="pridajKontakt()">Pridať kontaktnú osobu</v-btn>
                                <v-spacer />
                            </v-row>
                            <v-card v-if="pridat_kontakt==1 || editovany_kontakt > 0">
                                <v-card-title>
                                    <v-icon large class="btn-close" @click="pridat_kontakt = 0; editovany_kontakt = 0">close</v-icon>
                                    Kontaktná osoba
                                </v-card-title>
                                <v-card-text>
                                    <v-text-field v-model="osoba_meno" label="Meno" density="compact" variant="outlined"/>
                                    <v-text-field v-model="osoba_priezvisko" label="Priezvisko" density="compact" variant="outlined"/>
                                    <v-text-field v-model="osoba_email" label="E-mail" density="compact" variant="outlined" :rules="emailrules"/>
                                    <v-text-field v-model="osoba_telefon" label="Tel." density="compact" variant="outlined"/>
                                    <p v-if="kontakt_feedback.length>0" style="color:red">{{kontakt_feedback}}</p>
                                    <v-btn variant="outlined" @click="ulozKontakt()">Ulož kontaktnú osobu</v-btn>
                                </v-card-text>
                            </v-card>
                    </v-card-text>
                    <v-card-text>
                        <v-textarea v-model="napln_praxe" 
                                    label="Popis činností na praxi" 
                                    variant="outlined"
                                    rows="4"
                                    style="background-color:#E8F5E9"/>
                    </v-card-text>
                    <v-card-text>
                        <h3>Termín praxe:</h3>
                    </v-card-text>
                    <v-card-text>
                        <v-row>
                            <v-spacer />
                            <v-text-field                                
                                label="Začiatok"
                                v-model="start_date"
                                type="date"
                                variant="outlined"
                                />
                            <v-text-field                                
                                style="margin-left:10px"
                                label="Koniec"
                                v-model="end_date"
                                type="date"
                                variant="outlined"
                                />
                            <v-spacer />
                        </v-row>
                    </v-card-text>
                    <v-card-text style="background-color:#E8F5E9">
                        <p v-if="prax_feedback.length>0" style="color:red">{{prax_feedback}}</p>
                        <v-row style="margin:5px">
                            <v-spacer />
                            <v-btn variant="outlined" @click="ulozPrax()">Ulož</v-btn>
                            <v-spacer />
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-spacer />
            </v-row>
        </v-card-text>
    </v-card>    
</template>

<script>
import axios from '../../axios-auth.js'
import PracticeResults from '../../components/practice/practice_results.vue'


export default {
    data() {
        return {
            myData : null,
            MyFirmy: null,
            rozbalitTermin: -1,
            ludiaNaTermine: null,
            ukazat_prax: 0,
            selected_firm: null,
            pridat_kontakt: 0,
            editovany_kontakt: 0,
            pridat_firmu: 0,
            kontaktna_osoba_id: -1,
            start_date: null,
            end_date: null,
            napln_praxe: '',
            firma_nazov: '',
            firma_ulica: '',
            firma_mesto: '',
            firma_psc: '',
            firma_ico: '',
            osoba_meno: '',
            osoba_priezvisko: '',
            osoba_email: '',
            osoba_telefon: '',
            firma_feedback: '',
            kontakt_feedback: '',
            prax_feedback: '',
            emailrules: [
                value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }],
            ukaz_terminy: 0,
            ukaz_vysledky: 0,
            terminy: [],
            editovana_prax: 0,
            editovana_firma: 0
        }
    },
    mounted() {
        this.initData()
    },
    components: {
        PracticeResults
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.vycistiNastavenia()
            this.ukazat_prax = 0
            this.getUserPracticeData()
        },
        getUserPracticeData() {
            axios.get('/get-practice-user-data', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        nacitajFirmy(_prax = null) {
             axios.get('/get-practice-firms', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.MyFirmy = res.data 
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                if (_prax != null) {
                    for(let i=0; i<this.MyFirmy.firmy.length; i++) {
                        if (this.MyFirmy.firmy[i].id == _prax.firma_id) {
                            this.selected_firm = this.MyFirmy.firmy[i]
                        }
                    }
                    // kontaktnu osobu
                    this.kontaktna_osoba_id = _prax.kontakt_id
                    this.napln_praxe = _prax.napln_praxe
                    // datumy
                    this.start_date = new Date(''+_prax.od_rok+'-'+_prax.od_mesiac+'-'+_prax.od_den).toISOString().slice(0,10); 
                    this.end_date = new Date(''+_prax.do_rok+'-'+_prax.do_mesiac+'-'+_prax.do_den).toISOString().slice(0,10); 
                } else {
                    this.editovana_prax = -1
                    this.selected_firm = null
                    this.napln_prax = ''
                    this.start_date = new Date().toISOString().slice(0,10); 
                    this.end_date = new Date().toISOString().slice(0,10); 
                }
                this.ukazat_prax = 1
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        ulozKontakt() {
            this.clearFeedbacks()
            const _data = {
                kontakt_id : this.editovany_kontakt,
                firma_id: this.selected_firm.id,
                meno : this.osoba_meno,
                priezvisko : this.osoba_priezvisko,
                email : this.osoba_email,
                telefon : this.osoba_telefon
            }
            axios.post('/practice-save-person', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.kontakt_feedback = res.data.message
                    return
                }                 
                // najdi a prirad
                this.MyFirmy = res.data
                this.osoba_email = this.osoba_email.split(' ').join('');
                this.pridat_kontakt = 0
                this.editovany_kontakt = 0
                for(let i=0; i < this.MyFirmy.firmy.length; i++) {
                    if (this.MyFirmy.firmy[i].ico == this.selected_firm.ico){
                        this.selected_firm = this.MyFirmy.firmy[i]
                        for(let j = 0; j < this.selected_firm.kontakty.length; j++) {
                            if (this.selected_firm.kontakty[j].email == this.osoba_email) {
                                this.kontaktna_osoba_id = this.selected_firm.kontakty[j].id
                                return
                            }
                        }
                    }
                }                
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        ulozFirmu() {
            this.clearFeedbacks()
            const _data = {
                firma_id: this.editovana_firma,
                nazov: this.firma_nazov,
                ulica: this.firma_ulica,
                mesto: this.firma_mesto,
                psc: this.firma_psc,
                ico: this.firma_ico                
            }
            axios.post('/practice-save-firm', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.firma_feedback = res.data.message
                    return
                } 
                this.MyFirmy = res.data
                // najdi a prirad
                this.firma_ico = this.firma_ico.split(' ').join('');
                this.pridat_firmu = 0
                this.editovana_firma = 0
                for(let i=0; i < this.MyFirmy.firmy.length; i++) {
                    if (this.MyFirmy.firmy[i].ico == this.firma_ico){
                        this.selected_firm = this.MyFirmy.firmy[i]
                        return
                    }
                }                
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        ulozPrax() {
            this.clearFeedbacks()
            const od_rok = this.start_date.substring(0,4)
            const od_mesiac = this.start_date.substring(5,7)
            const od_den = this.start_date.substring(8,10)
            const do_rok = this.end_date.substring(0,4)
            const do_mesiac = this.end_date.substring(5,7)
            const do_den = this.end_date.substring(8,10)
            const _lng = (do_rok-od_rok) * 365 + (do_mesiac - od_mesiac)*30 + (do_den - od_den)
            if (_lng < 15) {
                this.prax_feedback = 'Uvedená doba nie je pre splnenie praxe reálna.'
                return
            }
            if (this.selected_firm == null || this.selected_firm.length == 0) {
                this.prax_feedback = 'Nie je vybratá firma.'
                return
            }
            if (this.kontaktna_osoba_id < 1) {
                this.prax_feedback = 'Nie je vybratá kontaktna osoba.'
                return
            }
            if (this.napln_praxe.length < 10) {
                this.prax_feedback = 'Popis náplne praxe je príliš krátky.'
                return
            }
            // vybrana firma s inou ako vybranou ko
            let _selected = false
            for(let i=0; i< this.selected_firm.kontakty.length; i++) {
                if (this.selected_firm.kontakty[i].id == this.kontaktna_osoba_id) _selected = true
            }
            if (!_selected) {
                this.prax_feedback = 'Nie je vybratá kontaktna osoba.'
                return
            }
            const _data = {
                prax_id: this.editovana_prax == -1 ? 0: this.editovana_prax,
                firma_id: this.selected_firm.id,
                kontakt_id : this.kontaktna_osoba_id,
                od_rok : od_rok,
                od_mesiac : od_mesiac,
                od_den : od_den,
                do_rok : do_rok,
                do_mesiac : do_mesiac,
                do_den : do_den,
                napln_praxe: this.napln_praxe
            }
            axios.post('/practice-save-practice', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.prax_feedback = res.data.message
                    return
                }                 
                this.myData = res.data
                this.ukazat_prax = 0
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },  
        ukazTerminy() {
            this.ukaz_terminy = 1
            this.ukaz_vysledky = 0
            this.ukazat_prax = 0
        },
        ukazVysledky() {
            this.ukaz_terminy = 0
            this.ukaz_vysledky = 1
            this.ukazat_prax = 0
        },
        zapisMa(_terminid, _praxid) {
            this.clearFeedbacks()
            const _data = {
                termin_id: _terminid,
                prax_id: _praxid
            }
            axios.post('/set-practice-user-to-term', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        odhlasMa(_terminid, _praxid) {
            const _data = {
                termin_id: _terminid,
                prax_id: _praxid
            }
            axios.post('/remove-practice-user-from-term', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        deletePrax(_id) {
            this.clearFeedbacks()
            const _data = {
                prax_id: _id
            }
            axios.post('/remove-practice', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })            
        },
        vymazKontakt(_id) {
            this.clearFeedbacks()
            if (_id == this.kontaktna_osoba_id) {
                this.kontakt_feedback = "Nemožno vymazať aktívnu kontaktnú osobu, najprv jej zrušte priradenie k praxi."
                return
            }
            const _data = {
                kontakt_id: _id
            }
            axios.post('/remove-contact', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.kontakt_feedback = res.data.message
                } else {
                    this.MyFirmy = res.data
                    for (let i = 0; i < this.MyFirmy.firmy.length; i++) {
                        if (this.MyFirmy.firmy[i].id == this.selected_firm.id) {
                            this.selected_firm = this.MyFirmy.firmy[i]
                        }
                    }                    
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })            
        },
        vymazFirmu(_id) {
            this.clearFeedbacks()
            if (this.selected_firm.kontakty.length > 0) {
                this.firma_feedback = "Nemožno vymazať firmu, pre ktorú sú definované kontakty. Najprv vymažte tie."
                return
            }
            const _data = {
                firma_id: _id
            }
            axios.post('/remove-firm', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.firma_feedback = res.data.message
                } else {
                    this.MyFirmy = res.data
                    this.selected_firm = null
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })            
        },
        clearFeedbacks() {
            this.firma_feedback = ''
            this.kontakt_feedback = ''
            this.prax_feedback = ''
            this.$store.commit('setFeedback', null)
        },
        editujPrax(_prax) {
            this.ukazat_prax = 1
            this.editovana_prax = _prax.id
            this.nacitajFirmy(_prax)           
        },
        pridajKontakt() {
            this.vycistiNastavenia()
            this.pridat_kontakt = 1
            this.osoba_meno = ''
            this.osoba_priezvisko = ''
            this.osoba_email = ''
            this.osoba_telefon = ''
        },
        editujKontakt(_osoba) {
            this.vycistiNastavenia()
            this.editovany_kontakt = _osoba.id
            this.osoba_meno = _osoba.meno
            this.osoba_priezvisko = _osoba.priezvisko
            this.osoba_email = _osoba.email
            this.osoba_telefon = _osoba.telefon
        },
        pridajFirmu() {
            this.vycistiNastavenia()
            this.pridat_firmu = 1
        },
        vycistiNastavenia() {
            this.pridat_kontakt = 0
            this.editovany_kontakt = 0
            this.pridat_firmu = 0
            this.editovana_firma = 0
        },
        editujFirmu(_firm) {
            this.vycistiNastavenia()
            this.editovana_firma = _firm.id
            this.firma_nazov = _firm.nazov
            this.firma_ulica = _firm.ulica
            this.firma_mesto = _firm.mesto
            this.firma_psc = _firm.psc
            this.firma_ico = _firm.ico
        }
    }
}
</script>
